module.exports = __webpack_public_path__ + "img/export_files_icon.206c6d12.svg";